import script from "./SelectIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectIcon.vue?vue&type=script&lang=ts&setup=true"

import "./SelectIcon.vue?vue&type=style&index=0&id=3aa360a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa360a6"]])

export default __exports__